module.exports = __webpack_public_path__ + "img/btn-armchair@1x.28231fae.png";